import { createContext, useContext } from 'react';
import type { HilChatMessageKind } from '../types/HilChatMessage';
import type { HilChatMessageRenderer } from '../settings/HilChatWindowSettings';

export type HilChatRendererMap = Partial<Record<HilChatMessageKind, HilChatMessageRenderer>>;

const HilChatRendererContext = createContext<HilChatRendererMap | null>(null);

export function useHilChatRenderer(kind: HilChatMessageKind): HilChatMessageRenderer | null {
  const map = useContext(HilChatRendererContext);
  return map?.[kind] ?? null;
}

export const HilChatRendererProvider = HilChatRendererContext.Provider;
